import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId, EASE } from "./Reveal";

const links = [
  { id: "nosotros", label: "Nosotros" },
  { id: "capacidades", label: "Capacidades" },
  { id: "categorias", label: "Categorías" },
  { id: "soluciones", label: "Soluciones" },
  { id: "proceso", label: "Proceso" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
      className={`fixed top-0 inset-x-0 z-50 transition-shadow duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-ecnavy/10 shadow-[0_4px_24px_rgba(22,48,92,0.06)]" : "bg-white/60 backdrop-blur-md"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <button onClick={() => window.__lenis?.scrollTo(0, { duration: 1.2 })} className="flex items-center gap-3" data-testid="navbar-logo">
          <img src="/assets/eclickgo-logo.webp" alt="eClickGo" className="h-9 w-auto" />
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollToId(l.id)}
              className="link-underline text-sm font-medium text-ecnavy/70 hover:text-ecnavy transition-colors"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          onClick={() => scrollToId("contacto")}
          className="rounded-full bg-ecnavy text-white text-sm font-semibold px-6 py-2.5 hover:bg-ecdeep transition-colors duration-300 shadow-[0_8px_24px_rgba(22,48,92,0.25)]"
          data-testid="nav-cta-button"
        >
          Solicitar cotización
        </button>
      </div>
    </motion.header>
  );
}
